import Checkbox from "./checkbox";
import Input from './input-with-label';

export default ({ handleChange = () => {}, values = {}, company_types = null, onCheckboxTypeChange = () => {}, validation = {} }) => {
    const types = {
        'Limited Company': {
            type: 'company_registration_number',
            value: 'Company registration number (8 character number)',
            max: 8,
        },
        'Sole Trader': {
            type: 'utr',
            value: 'UTR Number (This is your 10 character number)',
            max: 10,
        },
        'Charity': {
            type: 'charity_number',
            value: 'Charity Number (This is your 15 character number)',
            max: 15,
        },
        'Partnership': null,
        'Non-for-profit': null,
        'CIC Social Enterprise': null,
    }

    const type = (company_types != null && company_types.length !== 0) ? types[company_types]?.type : '';

    const onCheckbox = (e) => {
        const type = types[e.option]?.type || '';

        onCheckboxTypeChange({
            option: e.option,
            type: type,
        });
    }

    const onChange = (e) => {
        const { value } = e.target;

        let obj = {
            company_type: company_types,
        }

        if (type) {
            obj.company_number = value;
            obj.company_number_type = type;
        }

        handleChange(obj);
    }

    const validCompany = company_types !== null && company_types.length !== 0 && types[company_types] !== undefined && types[company_types] !== null;

    return (
        <>
            <div className='input-outer'>
                <label>What type of business are you?</label>

                <div className='registration-form__checkboxes utils__row gap'>
                    { Object.keys(types).map(key => {
                        return <Checkbox text={key} checked={company_types == key} onChange={onCheckbox}/>
                    }) }
                </div>

                { validation?.company_types?.message.length > 0 && <div className='input-outer__errors'><p>{ validation?.company_types?.message }</p></div> }
            </div>

            { validCompany && <Input label={types[company_types].value} type="text" name="company_number" placeholder="" max={types[company_types].max} value={values.company_number} onChange={onChange}/>}
        </>
    )
}